import api from '../services/api';

const CafeVerdeModel = {
    // Obtener todas las variedades
    getAll: async () => {
        try {
            const response = await api.get('/cafe-verde');
            return response.data;
        } catch (error) {
            console.error('Error obteniendo café verde:', error);
            return [];
        }
    },

    // Obtener una variedad por ID
    getById: async (id) => {
        try {
            const response = await api.get(`/cafe-verde/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error obteniendo variedad:', error);
            return null;
        }
    },

    // Crear nueva variedad
    create: async (data) => {
        try {
            const response = await api.post('/cafe-verde', data);
            return response.data;
        } catch (error) {
            console.error('Error creando variedad:', error);
            throw error;
        }
    },

    // Actualizar variedad
    update: async (id, data) => {
        try {
            const response = await api.put(`/cafe-verde/${id}`, data);
            return response.data;
        } catch (error) {
            console.error('Error actualizando variedad:', error);
            throw error;
        }
    },

    // Eliminar variedad (borrado lógico)
    delete: async (id) => {
        try {
            const response = await api.delete(`/cafe-verde/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error eliminando variedad:', error);
            throw error;
        }
    },

    // Cambiar disponibilidad
    toggleDisponible: async (id, disponible) => {
        try {
            const response = await api.patch(`/cafe-verde/${id}/disponible`, { disponible });
            return response.data;
        } catch (error) {
            console.error('Error cambiando disponibilidad:', error);
            throw error;
        }
    },

    // Obtener estadísticas
    getStats: async () => {
        try {
            const response = await api.get('/cafe-verde/stats');
            return response.data;
        } catch (error) {
            console.error('Error obteniendo estadísticas:', error);
            return {
                total_variedades: 0,
                stock_total: 0,
                certificaciones: 0,
                paises_importadores: 0
            };
        }
    }
};

export default CafeVerdeModel;